import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getFarmerDocuments(id) {
    return RetailerApiClient.get(`applications/${id}/farmer-documents`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadFarmerDocument(id, formData) {
    return RetailerApiClient.postForm(`applications/${id}/farmer-documents`, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteFarmerDocument(id, farmerDocumentId) {
    return RetailerApiClient.delete(`applications/${id}/farmer-documents/${farmerDocumentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
